import * as React from 'react';

import { useGalleryMortgageBannerDomBridge } from 'shared/hooks/mortgage/useGalleryMortgageBannerDomBridge';
import { TMortgageBannerVerticalName } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

import * as styles from './MortgageBanner.css';

interface IMortgageBannerProps {
  innerHTML: string;
  verticalName: TMortgageBannerVerticalName;
}

/* istanbul ignore next */
export const MortgageBanner: React.FC<React.PropsWithChildren<IMortgageBannerProps>> = ({
  innerHTML,
  verticalName,
}) => {
  const containerRef = useGalleryMortgageBannerDomBridge(innerHTML, verticalName);

  // eslint-disable-next-line react/no-danger
  return <div ref={containerRef} className={styles['container']} dangerouslySetInnerHTML={{ __html: innerHTML }} />;
};
